"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var CustomExample_1 = require("./CustomExample");
var SimpleExample_1 = require("./SimpleExample");
var Properties_1 = require("./Properties");
exports.ModalPage = function () { return (React.createElement(common_1.Page, { headerText: "Modal" },
    React.createElement(common_1.Paragraph, null, "Modal is used to focus on a new context without navigate to other page."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(SimpleExample_1.SimpleExample, null),
    React.createElement(CustomExample_1.CustomExample, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(Properties_1.Properties, null))); };
exports.ModalPage.displayName = 'ModalPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ModalPage/ModalPage.tsx
// module id = 698
// module chunks = 0